import { StrictMode } from "react"
import ReactDOM from "react-dom/client"

import { BootScreen } from "@/components/boot-screen"

// Kept deliberately tiny: React, the boot screen, and a dynamic import of everything
// else, so the loading state is on screen while the real bundle is still downloading.
const rootElement = document.getElementById("root")
if (!rootElement) throw new Error("Root element not found")
if (!rootElement.dataset.mounted) {
  rootElement.dataset.mounted = "true"
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <BootScreen />
    </StrictMode>
  )
  // A plain render, not a Suspense reveal: React holds a reveal until 300ms after its
  // fallback appeared, which delayed every fast load (llms/app-boot.md).
  void import("./app").then(({ default: App }) =>
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    )
  )
}
